
export default function ServiceSection() {
  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl font-bold text-gray-800 mb-8">サービス</h2>
        
        <div className="mb-12">
          <p className="text-xl text-gray-600 mb-6 font-medium">
            "全ての出発点は人生を変える出会いから"をモットーに、
          </p>
          <p className="text-lg text-gray-600 mb-8">
            あなたが望む見込み客やビジネスパートナーを紹介できる完全審査制の経営者向けメンバーシップクラブ
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center space-y-8 md:space-y-0 md:space-x-8">
          {/* Step 1 */}
          <div className="bg-teal-50 rounded-lg p-6 w-full md:w-64 h-40 flex flex-col justify-center">
            <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-white font-bold text-lg">1</span>
            </div>
            <h3 className="font-semibold text-gray-800 mb-2">会社情報登録</h3>
            <p className="text-sm text-gray-600">基本情報をご登録いただきます</p>
          </div>

          {/* Arrow */}
          <div className="hidden md:block">
            <div className="w-8 h-0.5 bg-teal-300"></div>
          </div>

          {/* Step 2 */}
          <div className="bg-teal-50 rounded-lg p-6 w-full md:w-64 h-40 flex flex-col justify-center">
            <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-white font-bold text-lg">2</span>
            </div>
            <h3 className="font-semibold text-gray-800 mb-2">面談（任意）</h3>
            <p className="text-sm text-gray-600">ご希望に応じて面談を実施</p>
          </div>

          {/* Arrow */}
          <div className="hidden md:block">
            <div className="w-8 h-0.5 bg-teal-300"></div>
          </div>

          {/* Step 3 */}
          <div className="bg-teal-50 rounded-lg p-6 w-full md:w-64 h-40 flex flex-col justify-center">
            <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-white font-bold text-lg">3</span>
            </div>
            <h3 className="font-semibold text-gray-800 mb-2">マッチングサポート</h3>
            <p className="text-sm text-gray-600">最適なパートナーをご紹介</p>
          </div>
        </div>
      </div>
    </section>
  );
}
